// Zjištění nové verze aplikace (app-build) a automatické obnovení.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { appearance } from './appearance.js';
import { state } from './state.js';

// ---------- update detection (new deploy while the app is open) ----------
// The app is one static HTML file with no build pipeline, so "is there a
// newer version live" is answered by comparing the <meta name="app-build">
// baked into THIS loaded page against a fresh, uncached fetch of the same
// URL. Checked on every tab switch (cheap, and that's the moment a reload
// is least disruptive) rather than on a timer, and skipped while an audit
// is actively being filled in so in-progress answers are never torn away.
var CURRENT_APP_BUILD = (function(){
  var m = document.querySelector('meta[name="app-build"]');
  return m ? m.getAttribute('content') : '';
})();
var updateCheckInFlight = false;
var updateCheckedAt = 0;
var UPDATE_CHECK_MIN_INTERVAL_MS = 60000; // nejvýš 1× za minutu (dřív při každém přepnutí obrazovky)
function checkForAppUpdate(){
  if(updateCheckInFlight) return;
  if(Date.now() - updateCheckedAt < UPDATE_CHECK_MIN_INTERVAL_MS) return;
  if(!CURRENT_APP_BUILD) return; // nothing to compare against
  if(state.draftAudit) return; // never interrupt an audit in progress
  updateCheckInFlight = true;
  updateCheckedAt = Date.now();
  // cache:'no-cache' = conditional request (If-None-Match): when nothing
  // was deployed the server answers 304 with no body and the browser hands
  // back its cached copy, instead of re-downloading the whole ~0.5 MB page
  // on every tab switch (Netlify bills bandwidth).
  // Vždy úvodní stránka aplikace (adresa stránky může být např. /historie/BOZP-12).
  fetch((import.meta.env && import.meta.env.BASE_URL) || '/', {cache:'no-cache'})
    .then(function(res){ return res.text(); })
    .then(function(html){
      var m = /<meta\s+name="app-build"\s+content="([^"]*)"/.exec(html);
      var liveBuild = m ? m[1] : '';
      if(liveBuild && liveBuild !== CURRENT_APP_BUILD && !state.draftAudit){
        location.reload();
      }
    })
    .catch(function(){ /* offline or request blocked — just skip this check */ })
    .finally(function(){ updateCheckInFlight = false; });
}

// Návrat do appky (z jiné aplikace / karty) — dobrá chvíle zkontrolovat
// novou verzi (také omezeno na 1× za minutu).
document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='visible') checkForAppUpdate(); });
function applyAppearance(){
  var root = document.documentElement;
  if(appearance.theme==='light') root.setAttribute('data-theme','light');
  else if(appearance.theme==='dark') root.setAttribute('data-theme','dark');
  else root.removeAttribute('data-theme');
  if(appearance.accent && appearance.accent!=='blue') root.setAttribute('data-accent', appearance.accent);
  else root.removeAttribute('data-accent');
  if(appearance.fontSize && appearance.fontSize!=='m') root.setAttribute('data-fontsize', appearance.fontSize);
  else root.removeAttribute('data-fontsize');
}
applyAppearance();

export {
  applyAppearance,
  checkForAppUpdate
};
